import {
    TablePlugin as SlateTablePlugin,
    TablePluginOptions,
    SlatePlugin,
} from '@udecode/slate-plugins';

export const TablePlugin = (options?: TablePluginOptions): SlatePlugin => ({
    ...SlateTablePlugin(options),
});
